import {
  ADD_NEWS,
  EDIT_NEWS,
  GET_NEWS,
  GET_NEWS_BY_ID,
  REMOVE_NEWS,
} from "../actions/news-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const newsReducer = (state = initialState, action: any): ApiRequestState => {
  switch (action.type) {
    case (ADD_NEWS.REQUEST,
    GET_NEWS.REQUEST,
    GET_NEWS_BY_ID.REQUEST,
    EDIT_NEWS.REQUEST,
    REMOVE_NEWS.REQUEST):
      return {
        ...state,
        loading: true,
        error: null,
      };
    case (ADD_NEWS.SUCCESS,
    GET_NEWS.SUCCESS,
    GET_NEWS_BY_ID.SUCCESS,
    EDIT_NEWS.SUCCESS,
    REMOVE_NEWS.SUCCESS):
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case (ADD_NEWS.FAILURE,
    GET_NEWS.FAILURE,
    GET_NEWS_BY_ID.FAILURE,
    EDIT_NEWS.FAILURE,
    REMOVE_NEWS.FAILURE):
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { newsReducer };
